import React from 'react';

const CustomerStatFilterContext = React.createContext({});

export default CustomerStatFilterContext;
